"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            borderRadius: 4,
            boxShadow: 'none',
            filter: "drop-shadow(".concat(theme_1.default.shadows.strongWithoutSpread, ")"),
            overflow: 'visible',
        },
        overflowHidden: {
            overflow: 'hidden',
        },
        overflowAuto: {
            overflow: 'auto',
        },
        triangleTip: {
            '&:after': {
                content: '""',
                position: 'absolute',
                height: 24 / Math.SQRT2,
                width: 24 / Math.SQRT2,
                clipPath: 'polygon(0% 0%, 100% 100%, 0% 100%)',
                borderRadius: '0 0 0 4px',
                backgroundColor: 'white',
            },
        },
        triangleTipBottom: {
            '&:after': {
                top: '100%',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(-45deg)',
            },
        },
        triangleTipTop: {
            '&:after': {
                top: 0,
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(135deg)',
            },
        },
        triangleTipRight: {
            '&:after': {
                top: '50%',
                right: 0,
                transform: 'translate(50%, -50%) rotate(-135deg)',
            },
        },
        triangleTipLeft: {
            '&:after': {
                top: '50%',
                left: 0,
                transform: 'translate(-50%, -50%) rotate(45deg)',
            },
        },
    });
});
